<template lang="pug">
#ToggleFullScreenButton.mt4
    button.sh4.pa1( @click.prevent="click" :class="{fullscreen} ")
      img(src="@/assets/fullscreen.png" style="width: 20px; height:20px;")

</template>

<script>
import { logEvent } from "@/api";
export default {
  name: "ToggleFullScreenButton",

  props: ["fullscreen"],
  data: () => ({}),
  created() {
    window.ToggleFullScreenButton = this;
  },
  methods: {
    click() {
      logEvent("toggle-fullscreen", true);
      this.$emit("toggle-fullscreen", !this.fullscreen);
    },
  },
};
</script>

<style scoped>
.pointer {
  cursor: pointer;
}

#ToggleFullScreenButton {
  text-align: right;
}

#ToggleFullScreenButton * {
  text-align: left;
}

.fullscreen {
  box-shadow: inset 4px 4px 6px rgba(0, 0, 0, 0.3);
  /* transform: translateY(4px); */
  background-color: #999;
}
</style>
